import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-line-chart-line',
    title: 'マーケティング支援',
    subtitle: 'Marketing Support',
    desc: '美容製品・サービスのマーケティング戦略立案から実行まで、トータルでサポートいたします。',
    details: [
      'SNS運用戦略の立案・実行支援',
      'デジタル広告（Instagram・TikTok・Google）の運用',
      'ブランドアイデンティティの構築',
      'コンテンツマーケティング支援',
      '競合分析・市場調査',

    ],
    img: 'https://readdy.ai/api/search-image?query=beauty%20marketing%20strategy%20elegant%20workspace%20laptop%20flowers%20minimal%20white%20light%20blue%20pastel%20feminine%20professional&width=600&height=400&seq=svc1&orientation=landscape',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '情報提供・コンサルティング',
    subtitle: 'Consulting',
    desc: '最新の美容トレンドと業界知識を活かした、実践的なコンサルティングを提供します。',
    details: [
      '美容業界トレンド情報の提供',
      'ビジネスモデルの見直し・改善提案',
      '新規事業立ち上げ支援',

      '販路拡大・パートナーシップ構築支援',
      '月次レポートと定期ミーティング',
    ],
    img: 'https://readdy.ai/api/search-image?query=beauty%20consulting%20meeting%20elegant%20professional%20woman%20desk%20minimal%20clean%20white%20office%20light%20blue%20accent%20flowers&width=600&height=400&seq=svc2&orientation=landscape',
  },
  {
    icon: 'ri-computer-line',
    title: 'オンライン講座・セミナー',
    subtitle: 'Online Courses',
    desc: '美容ビジネスに必要な知識とスキルを学べる、実践的なプログラムを企画・運営しています。',
    details: [
      '美容マーケティング基礎〜応用講座',
      'SNS活用・コンテンツ制作セミナー',
      'ブランディング戦略ワークショップ',
      'オンライン・オフライン両対応',
    ],
    img: 'https://readdy.ai/api/search-image?query=online%20beauty%20course%20seminar%20elegant%20woman%20learning%20laptop%20minimal%20clean%20white%20pastel%20light%20blue%20flowers%20desk&width=600&height=400&seq=svc3&orientation=landscape',
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <PageHero label="Services" title="サービス一覧" subtitle="美容ビジネスの成長を支える3つのコアサービスをご提供しています。" />

      {/* Services */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 space-y-20">
          {services.map((s, i) => (
            <div
              key={s.title}
              className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? 'md:flex-row-reverse' : ''}`}
            >
              <div className={i % 2 === 1 ? 'md:order-2' : ''}>
                <div className="rounded-2xl overflow-hidden h-72">
                  <img src={s.img} alt={s.title} className="w-full h-full object-cover object-top" />
                </div>
              </div>
              <div className={i % 2 === 1 ? 'md:order-1' : ''}>
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-sky-50 mb-5">
                  <i className={`${s.icon} text-sky-400 text-xl`}></i>
                </div>
                <span className="text-sky-400 text-xs tracking-widest uppercase">{s.subtitle}</span>
                <h2 className="text-2xl font-semibold text-slate-800 mt-2 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {s.title}
                </h2>
                <p className="text-slate-500 text-sm leading-relaxed mb-6">{s.desc}</p>
                <ul className="space-y-2">
                  {s.details.map((d) => (
                    <li key={d} className="flex items-center gap-3 text-sm text-slate-600">
                      <i className="ri-check-line text-sky-400 flex-shrink-0"></i>
                      {d}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-sky-50">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-light text-slate-800 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            まずはお気軽にご相談ください
          </h2>
          <p className="text-slate-500 text-sm mb-8">初回相談は無料です。お気軽にお問い合わせください。</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-sky-300 text-white text-sm font-medium hover:bg-sky-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            無料相談はこちら
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
